import type { ReactElement } from 'react';
import { AccountantReport } from './AccountantReport';
import { AccountingPolicy } from './AccountingPolicy';
import { Cic34Report } from './Cic34Report';
import { ClientReportFormat } from './ClientReportFormat';
import { CompanyContact } from './CompanyContact';
import { CompanyInfo } from './CompanyInfo';
import { CustomiseHeading } from './CustomiseHeading';
import { DirectorReport } from './DirectorReport';
import { ReportSettingRedirect } from './ReportSettingRedirect';
import { RevisedAccounts } from './RevisedAccounts';
import { ShareCapital } from './ShareCapital';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/taxreturns/settings-reportsettings': <CompanyInfo />,
  '/home/taxreturns/company-contact': <CompanyContact />,
  // APT337: the Report Settings page was removed (it duplicated Company Info); its URL lands on Company Info.
  '/home/taxreturns/report-setting': <ReportSettingRedirect />,
  '/home/taxreturns/director-report': <DirectorReport />,
  '/home/taxreturns/share-capital': <ShareCapital />,
  '/home/taxreturns/accountant-report': <AccountantReport />,
  '/home/taxreturns/accounting-policy': <AccountingPolicy />,
  '/home/taxreturns/customise-headings': <CustomiseHeading />,
  '/home/taxreturns/revised-accounts': <RevisedAccounts />,
  '/home/taxreturns/cic34-report': <Cic34Report />,
  '/home/taxreturns/cic-34-report': <Cic34Report />,
  // BUG-072: the earlier LLP Info URL opens the same page (LLP Info is Company Info for an LLP).
  '/home/taxreturns/llp-info': <CompanyInfo />,
  '/home/taxreturns/settings-reportformat': <ClientReportFormat />,
};
